import './App.css';
import './component/Style-css/Footer-Header.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import PrivateRoute from './component/PrivateRoute';
import Header from './component/navbar/Header';
import Footer from './component/Footer';

import Collect_event from './component/collect_images/Collect_event';
import Home from './component/home/Home';
import About from './component/About';
import Login_Register from './component/login/Login_Register';
import Dashboard from './component/dashboard/Dashboard';
import InEvent from './component/dashboard/InEvent';
import CameraCaptureWithMask from './component/collect_images/CameraCaptureWithMask';
import EmailVerified from './component/login/EmailVerify';
import ConfirmVerify from './component/login/ConfirmVerify';
import ForgetPass from './component/login/ForgetPass';
import AdminDashboard from './component/dashboard/AdminDashboard';
import Photographer from './component/dashboard/Photographer';
import UserPhotos from './component/dashboard/UserPhotos';
import AssignedEventPhotographer from './component/dashboard/AssignedEventPhotographer';
import AdminLogin from './component/login/AdminLogin';
import EventAnalytics from './component/dashboard/EventAnalytics';

function App() {
  return (
    <div className="App">
      <BrowserRouter>

        {/* Optional Header — Uncomment if you want it on every page */}
        {/* <Header /> */}

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login_Register />} />
          <Route path="/about" element={<About />} />
          <Route path="/forgetpassword" element={<ForgetPass />} />
          <Route path="/confirmed" element={<ConfirmVerify />} />
          <Route path="/emailverified" element={<EmailVerified />} />
          <Route path="/camera" element={<CameraCaptureWithMask />} />
          <Route path="/collect/:eventId" element={<CameraCaptureWithMask />} />

          {/* Protected Routes — use PrivateRoute if needed */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/in-event" element={<InEvent />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/analytics" element={<EventAnalytics />} />
          <Route path="/photographer" element={<Photographer />} />
          <Route path="/photographer/assigned-events" element={<AssignedEventPhotographer />} />
          <Route path="/user/photos" element={<UserPhotos />} />

          {/* Catch-all: Redirect any unknown route to Home */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>

        {/* Optional Footer — Uncomment if you want it on every page */}
        {/* <Footer /> */}

      </BrowserRouter>
    </div>
  );
}

export default App;
